import type {
  CheckPermissionPayload,
  CheckPermissionResult,
} from '@shared/services/caregivers/types/checkPermission.types';
import type { BuilderType } from '@shared/utils/api/configs/rtkBaseQueryDemo';
import { CHECK_PERMISSION_URL } from '@shared/utils/api/configs/URL';
import { hasCcdpSuccess } from '@shared/utils/api/handlers/interpretCcdpCode/interpretCcdpCode';
import type { GenericApiResponse } from '@shared/utils/api/types';

export const checkCaregiverPermission = (builder: BuilderType) =>
  builder.query<CheckPermissionResult, CheckPermissionPayload>({
    keepUnusedDataFor: 0,
    query: (data) => ({
      data,
      isErrMsgConcatErrCode: false,
      method: 'POST',
      url: CHECK_PERMISSION_URL,
    }),
    transformResponse: (response: GenericApiResponse<CheckPermissionResult>) => {
      if (hasCcdpSuccess(response)) {
        return response.Result;
      }

      throw {
        code: response.Code,
        message: response.Message,
      };
    },
  });
